import ConversationContent from '@/api/conversationContent';
import Exercise from '@/api/exercise';
import { cloneDeep, isEmpty, isNil } from 'lodash';
import { createMediaField } from '../common/util';

export async function copyConversationContent(
  exercise: Exercise,
  sourceConversation: ConversationContent
) {
  if (isNil(exercise.conversation_content) || isNil(sourceConversation)) {
    return;
  }

  const conversation = exercise.conversation_content;
  conversation.parent_exercise = exercise.id;
  conversation.transcription = sourceConversation.transcription;
  conversation.sentence = sourceConversation.sentence;
  conversation.sentence_i18n = sourceConversation.sentence_i18n;
  conversation.lesson_video_list = cloneDeep(
    sourceConversation.lesson_video_list
  );
  conversation.lesson_video = cloneDeep(sourceConversation.lesson_video);
  conversation.image_path = sourceConversation.image_path;

  const id = await conversation.save();

  if (!isEmpty(sourceConversation.audio_link)) {
    const mediaId = await createMediaField(
      sourceConversation.audio_link,
      id,
      'exerciseconversationcontent',
      'audio'
    );

    conversation.audio_path = mediaId;
  }

  return conversation.save();
}
